import React, { useCallback, useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useNavigate } from "react-router-dom";
import group1 from "../../assets/images/brand/Group1.png";
import group2 from "../../assets/images/brand/Group2.png";
import group3 from "../../assets/images/brand/Group3.png";
// WHAT: hardcoded static logo import kept as a fallback only (per
// code-integrity.md Zero Code Deletion rule) — the page now renders the
// admin-uploaded logo (see logoUrl state + fetchLogo effect below) instead.
// WHY: User instruction (2026-09-24) — logo should come from the same
// template-config upload (GET /api/logo) used elsewhere (createAccount.tsx,
// superAdmin/logo/logo.tsx), not a bundled static asset, so uploading a new
// logo in the admin panel updates this page too without a code deploy.
import icon from "../../assets/images/brand/logo_2_107x70.png";
import tickGreen from "../../assets/images/gif/geentick.gif";
import InputForm from "../../components/InputForm";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
import { BASE_URL, RECAPTCHA_SITE_KEY } from "../../constants/Constants";
import { useUser } from "../../contexts/UserContext";
import { useSetUserRegistration } from "../../contexts/UserRegistrationContext";
import { TRegistrationField } from "../../hooks/registration-field-hooks";
import { _axios } from "../../utils/axios";
import uploadFileToBlob from "../../utils/azure-storage-blob";
import { debounce } from "../../utils/common";
import { cookieUtils } from "../../utils/cookieUtils";
import style from "../verificationPage/verifcation.module.css";
import { validateDocuments } from "./VerificationPage.const";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { uploadFilesToServer } from "../../utils/fileUpload";

// Extend the JwtPayload interface
interface ExtendedJwtPayload extends JwtPayload {
  verified?: boolean;
}

const VerificationPage = () => {
  const [step, setStep] = useState(1);
  const [emailOTP, setEmailOTP] = useState('');
  const [mobileOTP, setMobileOTP] = useState('');
  const [documentType, setDocumentType] = useState('Aadhaar Card');
  const [documentId, setDocumentId] = useState('');
  const [regestrationFields, setRegestrationFields] = useState<any>([]);
  const [documentConfigList, setDocumentConfigList] = useState<any>();
  const [fileTypes, setFileTypes] = useState<Array<string>>(["JPG", "PNG", "GIF", "PDF"]);
  const setUserRegistration = useSetUserRegistration()
  let navigate = useNavigate();
  const user = useUser();
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [token, setToken] = useState('');
  const [verificationToken, setVerificationToken] = useState(null);
  // WHAT (new): admin-uploaded logo URL, fetched from the same endpoint
  // createAccount.tsx/superAdmin/logo/logo.tsx already use.
  // WHY: User instruction (2026-09-24) — replace the hardcoded static logo
  // asset with the template-config upload URL, so admins can change the
  // logo from /logo without a code deploy.
  const [logoUrl, setLogoUrl] = useState<string>('');

  useEffect(() => {
    _axios.get(`${BASE_URL}/api/logo`)
      .then((response) => {
        if (response?.data?.success === 1 && response?.data?.url) {
          setLogoUrl(response.data.url);
        }
      })
      .catch((error) => {
        console.error('Error fetching logo:', error);
      });
  }, []);
  const [isPlotOwner, setIsPlotOwner] = useState(false);
  const [nextRedirect, setNextRedirect] = useState<string | null>(null);

  const [formData, setFormData] = useState<any>(() => {
    const userData = cookieUtils.getSecureCookie('userDetails')
    const userParsedData = userData ? userData : {
      name: '',
      email: '',
      mobile_number: ''
    }
    return {
      name: userParsedData?.name,
      email: userParsedData?.email,
      mobile_number: userParsedData?.mobile,
      user_salutation: 'Mr.',
      user_type: 'Architect',
      document_type: 'Aadhaar Card',
      gov_id_number: '',
      office_address: '',
      gov_id_document: '',
      document_certificate: '',
      experience_certificate: '',
      licence_certificate: '',
      email_status: 0,
      mobile_status: 0,
      regestration_status: 0,
      registration_fee_receipt: '',
    }
  });

  const handleVerify = (token: React.SetStateAction<string>) => {
    setToken(token);
  };

  // Track if user type is Plot Owner
  useEffect(() => {
    setIsPlotOwner(formData.user_type === 'Plot Owner');
  }, [formData.user_type]);

  /*
    ORIGINAL CODE PRESERVED FOR COMPARISON (per code-integrity.md Zero Code Deletion rule)
    WHAT: isFeeApplicable used to gate the "Registration Fee Receipt" upload for
          Engineer/Supervisor only.
    WHY CHANGED: User instruction (2026-09-24) — the ₹3000 Engineer/Supervisor/Diploma
          Holder charge box was removed and replaced with a single
          "Architect Registration Charges - ₹2000" charge, so the fee-receipt upload
          gate must follow the fee to Architect instead.

    const isFeeApplicable =
      formData.user_type === "Engineer" ||
      formData.user_type === "Supervisor";
  */
  const isFeeApplicable = formData.user_type === "Architect";

  const convertFileTypeStringToArray = (fileTypesString: string) => {
    const fileTypesArray = fileTypesString.split(',');
    const capitalizedFileTypesArray = fileTypesArray.map(fileType => fileType.toUpperCase());
    return capitalizedFileTypesArray;
  }

  const getDocumentConfig = () => {
    _axios.get(`${BASE_URL}/api/document-config/regestration`)
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        setDocumentConfigList(response.data.data[0])
        setFileTypes(convertFileTypeStringToArray(response.data.data[0].file_type)?.filter(e => !!e))
        console.log('setDocumentConfigList', response);
      })
      .catch(function (error: any) {
        console.log(error);
      })
      .finally(function () {
      });
  }

  const getRegistrationFields = () => {
    _axios.post(`${BASE_URL}/api/registration-fields`,
      {
        "page": 1,
        "limit": 10
      })
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        setRegestrationFields(response.data.data)
        console.log(response);
      })
      .catch(function (error: any) {
        console.log(error);
      })
      .finally(function () {
      });
  }

  useEffect(() => {
    getRegistrationFields();
    getDocumentConfig()
  }, [])

  const sendEmail = () => {
    const userData = cookieUtils.getSecureCookie('userDetails')
    const userParsedData = userData ? userData : {
      user_id: ''
    }
    _axios.post(`${BASE_URL}/api/email-verification/sent`,
      {
        user_id: userParsedData.user_id,
        name: formData?.name,
        email: formData?.email,
        mobile_number: formData?.mobile_number,
        "token": token
      })
      .then(function (response: any) {
        console.log('response', response);

        // Store verification token if it exists in response
        if (response.data.verificationToken) {
          setVerificationToken(response.data.verificationToken);
          console.log('Verification token received:', response.data.verificationToken);
        }

        if (step !== 3) setStep(step + 1);

        if (response.data.success === 0) {
          ErrorToast(response.data.message);
        } else {
          SuccessToast('OTP sent Successfully');
        }
      }).catch(function (error) {
        console.log(error);
      })
  }

  const handleNext = async () => {
    if (step === 1) {
      const adharCardRegex = /^(?:\d{4} \d{4} \d{4}|\d{4}-\d{4}-\d{4}|\d{12})$/;
      const drivingLicenceRegex = /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/gm;
      const panCardRegex = /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/;
      const voterCardRegex = /^([a-zA-Z]){3}([0-9]){7}?$/g;
      const passportRegex = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;

      if (documentType === 'Aadhaar Card') {
        const isValid = adharCardRegex.test(documentId);
        if (!isValid) {
          ErrorToast("Check to ensure you entered the correct 12-digit Aadhaar number");
          return;
        }
      }
      else if (documentType === 'Driving Licence') {
        const isValid = drivingLicenceRegex.test(documentId);
        if (!isValid) {
          ErrorToast("Please ensure that any letters, numbers, or spaces included in your application match those on your physical license.")
          return;
        }
      }
      else if (documentType === 'Pan Card') {
        const isValid = panCardRegex.test(documentId);
        if (!isValid) {
          ErrorToast("Please verify that you have inputted the appropriate 10-character alphanumeric PAN number. For instance: XXXXX0000X.")
          return;
        }
      }
      else if (documentType === 'Voter Card') {
        const isValid = voterCardRegex.test(documentId);
        if (!isValid) {
          ErrorToast("Check that you have provided the correct Voter ID number. Voter ID numbers come in different lengths and formats.")
          return;
        }
      }
      else if (documentType === 'Passport') {
        const isValid = passportRegex.test(documentId);
        if (!isValid) {
          ErrorToast("Ensure that you have entered the correct passport number. Passport numbers typically include both letters and numbers.")
          return;
        }
      }

      let filtredList = regestrationFields?.filter((field: any) => field?.mandatory == 1);
      if (filtredList?.length > 0) {
        let index = filtredList.map((list: any) => list.registration_field_id);
        if (index.includes(7) && formData?.office_address.length < 1) {
          ErrorToast("Please enter valid address");
          return;
        }
      }
      setStep(step + 1)
    }
    else if (step === 2) {
      if (!documentConfigList?.file_size) {
        ErrorToast(`Document Config for Registration Document is not Configured by the Admin`)
      }
      else {
        const validRes = validateDocuments(documentConfigList, formData, formData.user_type)
        if (validRes.valid) sendEmail()
        else ErrorToast(validRes.message)
      }
    }
    else if (step === 3) {
      debouncedHandleNext();
    }
    else {
      setStep(step + 1);
    }
  };

  const handleSubmit = async () => {
    if (emailOTP.length > 5 || mobileOTP.length > 5) {
      setIsSubmitting(true);
      const userData = cookieUtils.getSecureCookie('userDetails')
      const userParsedData = userData ? userData : {
        user_id: ''
      }

      _axios.post(`${BASE_URL}/api/email-verification/verify`,
        {
          user_id: userParsedData.user_id,
          name: formData?.name,
          email: formData?.email,
          mobile_number: formData?.mobile_number,
          otp: emailOTP.length > 5 ? emailOTP : mobileOTP,
          verificationToken: verificationToken,
          token: token
        })
        .then(async function (response) {
          console.log('verification response', response);

          // Decode the token
          const decodedToken = jwtDecode(response?.data?.verificationToken) ?? {};

          if (decodedToken && Object.keys(decodedToken)?.length === 0) {
            ErrorToast("Something Wrong");
            setIsSubmitting(false);
            return;
          }

          if (decodedToken && 'verified' in decodedToken && (decodedToken as any).verified === true) {
            // Store new verification token if provided
            if (response.data.verificationToken) {
              setVerificationToken(response.data.verificationToken);
            }

            try {
              console.log('Starting file uploads...');

              // Create a dynamic files object - only include files that exist
              const filesToUpload: any = {};

              if (formData.gov_id_document) {
                filesToUpload.gov_id_document = formData.gov_id_document;
              }
              if (formData.document_certificate) {
                filesToUpload.document_certificate = formData.document_certificate;
              }
              if (formData.licence_certificate) {
                filesToUpload.licence_certificate = formData.licence_certificate;
              }
              if (formData.experience_certificate) {
                filesToUpload.experience_certificate = formData.experience_certificate;
              }
              if (formData.registration_fee_receipt) {
                filesToUpload.registration_fee_receipt =
                  formData.registration_fee_receipt;
              }


              // Upload files dynamically
              const fileUploadData = await uploadFilesToServer(
                filesToUpload,
                user?.user_id ?? '',
                'user_details'
              );

              console.log('Files uploaded successfully:', fileUploadData);
              console.log('File uploads completed, saving user details...');

              const userDetailsResponse = await _axios.post(`${BASE_URL}/api/user-details`, {
                user_id: userParsedData.user_id,
                name: formData?.name,
                email: formData?.email,
                mobile_number: formData?.mobile_number,
                user_salutation: formData?.user_salutation,
                user_type: formData?.user_type,
                document_type: formData?.document_type,
                gov_id_number: formData?.gov_id_number,
                office_address: formData?.office_address,
                gov_id_document: (fileUploadData as any)?.gov_id_document || '',
                document_certificate: (fileUploadData as any)?.document_certificate || '',
                experience_certificate: (fileUploadData as any)?.experience_certificate || '',
                registration_fee_receipt:
                  (fileUploadData as any)?.registration_fee_receipt || '',
                licence_certificate: (fileUploadData as any)?.licence_certificate || '',
                email_status: formData?.email_status,
                mobile_status: formData?.mobile_status,
                regestration_status: formData?.regestration_status,
                token: token
              });

              console.log('User details saved successfully:', userDetailsResponse);
              setUserRegistration(userDetailsResponse?.data?.data?.[0]);

              // Check if Plot Owner auto-approved
              const isAutoApproved = userDetailsResponse?.data?.auto_approved || false;

              // Only save verification comment if NOT Plot Owner (not auto-approved)
              if (!isAutoApproved) {
                console.log('Saving user verification comments...');
                await _axios.post(`${BASE_URL}/api/user-verification-comments`, {
                  user_id: userParsedData?.user_id,
                  name: userParsedData?.name,
                  email: userParsedData?.email,
                  comment: 'Registration request is currently under review.',
                  comments_by: "user",
                  status: 0
                });
              } else {
                console.log('Plot Owner auto-approved - skipping verification comment');
              }

              console.log('All data saved successfully! Redirecting...');

              setTimeout(() => {
                setIsSubmitting(false);
                setStep(step + 1);
              }, 3000);

            } catch (error: any) {
              console.error('Error during data saving process:', error);
              if (error.response?.data?.message) {
                ErrorToast(error.response.data.message);
              } else {
                ErrorToast('Failed to save registration data. Please try again.');
              }
              setIsSubmitting(false);
            }
          } else {
            ErrorToast('Email verification failed. Please try again.');
            setIsSubmitting(false);
          }

          if (response?.data?.status == "not verified") {
            ErrorToast('Please enter correct OTP')
            setIsSubmitting(false);
          }
        }).catch(function (error: any) {
          console.error('Verification request error:', error);
          if (error.response?.data?.message) {
            ErrorToast(error.response.data.message);
          } else {
            ErrorToast('Verification failed. Please try again.');
          }
          setIsSubmitting(false);
        })
    }
    else {
      ErrorToast('Please enter 6 digit OTP');
    }
  };

  const debouncedHandleNext = useCallback(debounce(handleSubmit, 3000), [emailOTP, mobileOTP, formData]);

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  const clearAuthAndLogout = () => {
    cookieUtils.removeSecureCookie("userDetails");
    cookieUtils.removeSecureCookie("token");
    cookieUtils.removeSecureCookie("subRole");
    cookieUtils.removeSecureCookie("userRegistrationDetails");
    localStorage.clear();
  };

  useEffect(() => {
    if (step === 4) {
      setTimeout(() => {
        clearAuthAndLogout();
        navigate("/onboarding/login", { replace: true });
      }, 3000);
    }
  }, [step, navigate]);

  const userTypeField = regestrationFields?.find((field: any) => field?.uid === 'user_type' && field?.active && field?.options?.length)

  return (
    <div className={style.pageContainer}>
      <div className={style.formPage}>
        <div className={style.logo}>
          {/* WHAT: src now uses the admin-uploaded logoUrl (GET /api/logo),
              falling back to the bundled static `icon` asset only until
              that fetch resolves (or if it ever fails/returns empty).
              WHY: User instruction (2026-09-24) — logo should come from the
              template-config upload location, not a hardcoded asset. */}
          <img src={logoUrl || icon} alt="Logo" style={{ display: 'inline' }} />
        </div>

        {step === 1 && (
          <>
            <h5 className={style.mainHeading}>Verification</h5>
            <div className={style.verificationContainer}>
              <img src={group1} alt="Logo" className={style.groupLogo} />
              <br />
              <h5 className={style.semiHeading}>Personal Details</h5>
              <div className={style.inputGroup}>
                {regestrationFields?.find((field: any) => field?.registration_field_id == 1 && field?.active == 1) && <div className={style.inputField}>
                  <InputForm
                    title={regestrationFields?.find((field: any) => field?.registration_field_id == 1)?.label_name}
                    isRequired={regestrationFields?.find((field: any) => field?.registration_field_id == 1 && field?.mandatory == 1) ? true : false}
                    isIcon={true}
                    icon={"fa fa-user-o"}
                    placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 1)?.placeholder_name ?? "Full Name"}
                    type="text"
                    isName={true}
                    disabled
                    value={formData.name}
                    onSuffixChange={(event) => { setFormData({ ...formData, user_salutation: event.target.value }) }}
                  />
                </div>}

                {regestrationFields?.find((field: any) => field?.registration_field_id == 2 && field?.active == 1) && <div className={style.inputField}>
                  <InputForm
                    title={regestrationFields?.find((field: any) => field?.registration_field_id == 2)?.label_name}
                    isRequired={regestrationFields?.find((field: any) => field?.registration_field_id == 2 && field?.mandatory == 1) ? true : false}
                    isIcon={true}
                    icon={"fa fa-envelope-o"}
                    placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 2)?.placeholder_name ?? "Email"}
                    type="email"
                    disabled
                    value={formData.email}
                  />
                </div>}
              </div>

              <div className={style.inputGroup}>
                {regestrationFields?.find((field: any) => field?.registration_field_id == 3 && field?.active == 1) && <div className={style.inputField}>
                  <InputForm
                    title={regestrationFields?.find((field: any) => field?.registration_field_id == 3)?.label_name}
                    isRequired={regestrationFields?.find((field: any) => field?.registration_field_id == 3 && field?.mandatory == 1) ? true : false}
                    isIcon={true}
                    icon={"fa fa-mobile-phone fa-lg"}
                    placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 3)?.placeholder_name ?? "Mobile Number"}
                    type="tel"
                    disabled
                    value={formData.mobile_number}
                  />
                </div>}

                {!!userTypeField && (
                  <div className={style.inputField}>
                    <legend className={style.legendTag}>
                      {userTypeField?.label_name || "User Type"}
                      {!!userTypeField?.mandatory && (
                        <span className="text-red-500">{" *"}</span>
                      )}
                    </legend>
                    <select
                      id="role"
                      name="role"
                      className={style.dropdownMenu}
                      value={formData.user_type}
                      onChange={(e) => {
                        setFormData({ ...formData, user_type: e.target.value });
                      }}
                    >
                      {userTypeField?.options?.filter((e: NonNullable<TRegistrationField['options']>[number]) => !!e?.active)?.map((opt: NonNullable<TRegistrationField['options']>[number]) => (
                        <option key={opt?.id || opt.name} value={opt.name}>
                          {opt.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>

              <div className={style.inputGroup}>
                {regestrationFields?.find((field: any) => field?.registration_field_id == 5 && field?.active == 1) && <div className={style.inputField}>
                  <legend className={style.legendTag}>
                    {regestrationFields?.find((field: any) => field?.registration_field_id == 5)?.label_name}
                    {regestrationFields?.find((field: any) => field?.registration_field_id == 5 && field?.mandatory == 1) && <span className="text-red-500">{' *'}</span>}
                  </legend>
                  <select id="role" name="role" className={style.dropdownMenu} value={formData.document_type} onChange={(e) => { setFormData({ ...formData, document_type: e.target.value }); setDocumentType(e.target.value) }}>
                    <option value="Aadhaar Card">Aadhaar Card</option>
                    <option value="Driving Licence">Driving Licence</option>
                    <option value="Pan Card">Pan Card</option>
                    <option value="Voter Card">Voter Card</option>
                    <option value="Passport">Passport</option>
                  </select>
                </div>}

                {regestrationFields?.find((field: any) => field?.registration_field_id == 6 && field?.active == 1) && <div className={style.inputField}>
                  <InputForm
                    title={documentType}
                    isRequired={regestrationFields?.find((field: any) => field?.registration_field_id == 6 && field?.mandatory == 1) ? true : false}
                    isIcon={true}
                    icon={"fa fa-credit-card"}
                    placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 6)?.placeholder_name ?? "Enter Number"}
                    type="text"
                    value={documentId}
                    onChange={(e) => { setFormData({ ...formData, gov_id_number: e.target.value }); setDocumentId(e.target.value) }}
                  />
                </div>}
              </div>

              {regestrationFields?.find((field: any) => field?.registration_field_id == 7 && field?.active == 1) && <div className={style.inputField}>
                <p className={style.officeLabel}>
                  {regestrationFields?.find((field: any) => field?.registration_field_id == 7)?.label_name}
                  {regestrationFields?.find((field: any) => field?.registration_field_id == 7 && field?.mandatory == 1) && <span className="text-red-500">{' *'}</span>}
                </p>
                <textarea
                  onChange={(e) => {
                    const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9\s-/]/g, '');
                    setFormData({ ...formData, office_address: sanitizedValue });
                  }}
                  placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 7)?.placeholder_name ?? "Enter Office Address"}
                  value={formData?.office_address ?? ''}
                  required
                ></textarea>
              </div>}
            </div>
          </>
        )}

        {step === 2 && (
          <>
            {/* <GoogleReCaptchaProvider reCaptchaKey="6Ldy7j0sAAAAAK96npJL_p3ghiggm7ew8TN4V6U2"> */}
            {/*
              ORIGINAL CODE PRESERVED FOR COMPARISON (per code-integrity.md Zero Code Deletion rule)
              WHAT: This block showed two charge boxes — "Plot Owner / Architect" (Not Applicable)
                    and "Engineer / Supervisor / Diploma Holder" (₹3000/-).
              WHY CHANGED: User instruction (2026-09-24) — remove the Engineer/Supervisor/Diploma
                    Holder charge box and change the display to a single
                    "Architect Registration Charges - ₹2000" charge instead.

              <div className={style.registrationCharges}>
                <h3 className={style.chargesTitle}>One Time Registration Charges</h3>
                <div className={style.chargesContainer}>
                  <div className={style.chargeBox}>
                    <p className={style.chargeFor}>For Plot Owner / Architect</p>
                    <p className={style.chargeAmount}>Not Applicable</p>
                  </div>
                  <div className={style.chargeBox}>
                    <p className={style.chargeFor}>For Engineer / Supervisor / Diploma Holder</p>
                    <p className={style.chargeAmount}>₹ 3000/-</p>
                  </div>
                </div>
                <div className={style.registrationFeeInfo}>
                  <p>Engineer / Supervisor please pay this registration amount in Nagar Panchayat</p>
                  <p>and upload the payment receipt below.</p>
                </div>
              </div>
            */}
            {/* WHAT: registrationCharges box label and amount now both
                follow formData.user_type — label reads
                "<Plot Owner|Architect> Registration Charges" and amount is
                ₹2000/- for Architect, NA otherwise.
                WHY: User instruction (2026-09-24) — the label was hardcoded
                to "Architect Registration Charges" even while showing NA
                for Plot Owner, which was confusing/wrong; it must say
                "Plot Owner Registration Charges" when that type is
                selected, now that Engineer/Supervisor were deactivated from
                the User Type dropdown leaving only Plot Owner and Architect
                selectable. */}
            <div className={style.registrationCharges}>
              <h3 className={style.chargesTitle}>One Time Registration Charges</h3>
              <div className={style.chargesContainer}>
                <div className={style.chargeBox}>
                  <p className={style.chargeFor}>{formData?.user_type || "Plot Owner"} Registration Charges</p>
                  <p className={style.chargeAmount}>
                    {formData?.user_type === "Architect" ? "₹ 2000/-" : "NA"}
                  </p>
                </div>
              </div>
              <div className={style.registrationFeeInfo}>
                <p>Architect please pay this registration amount in Nagar Panchayat</p>
                <p>and upload the payment receipt below.</p>
              </div>
            </div>
            <h5 className={style.mainHeading}>Verification</h5>
            <img src={group2} alt="Logo" className={style.groupLogo} />
            <h5 className={style.semiHeading}>Upload Documents</h5>
            <span className={style.browseLabel}>{documentType} *</span>
            <div className={style.uploadSection}>
              <FileUploader handleChange={(e: any) => { setFormData({ ...formData, gov_id_document: e }) }} name="file" types={fileTypes} children={
                <div className={style.uploadContainerDocument}>
                  <label className={style.uploadLable}>Browse</label>
                  <p className={`${style.linkCss} md:w-full lg:w-full`}>
                    {formData?.gov_id_document != '' ? formData?.gov_id_document?.name : 'Drag and drop file here'}
                  </p>
                </div>
              } />
            </div>

            {formData?.user_type === "Architect" && (
              <>
                <p className={style.browseLabel}>Degree Certificate *</p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => { setFormData({ ...formData, document_certificate: e }); }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.document_certificate != "" ? formData?.document_certificate?.name : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>

                <p className={style.browseLabel}>Architect License Certificate *</p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => { setFormData({ ...formData, licence_certificate: e }); }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.licence_certificate != "" ? formData?.licence_certificate?.name : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>
              </>
            )}

            {formData?.user_type === "Engineer" && (
              <>
                <p className={style.browseLabel}>Degree Certificate *</p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => { setFormData({ ...formData, document_certificate: e }); }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.document_certificate != "" ? formData?.document_certificate?.name : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>

                <p className={style.browseLabel}>Engineer License Certificate *</p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => { setFormData({ ...formData, licence_certificate: e }); }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.licence_certificate != "" ? formData?.licence_certificate?.name : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>
              </>
            )}

            {formData?.user_type === "Supervisor" && (
              <>
                <p className={style.browseLabel}>Highest Education Certificate *</p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => { setFormData({ ...formData, document_certificate: e }); }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.document_certificate != "" ? formData?.document_certificate?.name : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>

                <p className={style.browseLabel}>Experience Certificate *</p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => { setFormData({ ...formData, experience_certificate: e }); }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.experience_certificate != "" ? formData?.experience_certificate?.name : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>
              </>
            )}
            {isFeeApplicable && (
              <>
                <p className={style.browseLabel}>Registration Fee Receipt *</p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) =>
                      setFormData({ ...formData, registration_fee_receipt: e })
                    }
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.registration_fee_receipt
                            ? formData.registration_fee_receipt.name
                            : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>
              </>
            )}

            {/* <GoogleReCaptcha onVerify={handleVerify} /> */}
            {/* </GoogleReCaptchaProvider> */}
          </>
        )}

        {step === 3 && (
          <>
            {/* <GoogleReCaptchaProvider reCaptchaKey="6Ldy7j0sAAAAAK96npJL_p3ghiggm7ew8TN4V6U2"> */}
            <h5 className={style.mainHeading}>Verification</h5>
            <img src={group3} alt="Logo" className={style.groupLogo} />
            <h5 className={style.semiHeading}>OTP Verification</h5>
            <br />
            <div className={style.otpBox}>
              <div className={style.loginEmail}>
                <InputForm
                  title={"Enter Email OTP"}
                  placeholder={"Enter Email OTP"}
                  value={emailOTP}
                  onChange={(e) => setEmailOTP(e.target.value)}
                  type="text"
                />
                <div className={style.verificationMessage}>
                  Your OTP will expire in 10 min. In case OTP not received <span style={{ cursor: 'pointer' }} onClick={sendEmail}>Click here</span>
                </div>
              </div>

              <br />
              <h4 className="pb-4">OR</h4>

              <div className={style.loginEmail}>
                <InputForm
                  title={"Enter Mobile OTP"}
                  placeholder={"Enter Mobile OTP"}
                  value={mobileOTP}
                  onChange={(e) => setMobileOTP(e.target.value)}
                  type="text"
                />
                <div className={style.verificationMessage}>
                  Your OTP will expire in 10 min. In case OTP not received <span style={{ cursor: 'pointer' }} onClick={sendEmail}>Click here</span>
                </div>
              </div>
            </div>
            {/* <GoogleReCaptcha onVerify={handleVerify} /> */}
            {/* </GoogleReCaptchaProvider> */}
          </>
        )}

        {step === 4 && (
          <>
            <div className={style.verificationContainer}>
              <img src={tickGreen} alt="Logo" className={style.tickDone} />
              <h2 className={style.boldGreen}>Congratulations!!!</h2>

              {isPlotOwner ? (
                <h6 className={style.successfulMessage}>
                  Your account has been created successfully!<br />
                  You can now start applying for R.L.
                </h6>
              ) : (
                <h6 className={style.successfulMessage}>
                  You have registered successfully, you will receive <br />
                  the registration approval status on <br />
                  registered Email ID and Mobile Number
                </h6>
              )}
            </div>
          </>
        )}

        {step !== 4 && (
          <>
            {step !== 1 && <button className={style.blackBtn} onClick={handleBack}>Back</button>}
            <button
              className={style.yellowBtn}
              onClick={step === 3 ? handleSubmit : handleNext}
              disabled={isSubmitting}
            >
              {step === 3 ? (isSubmitting ? "Submitting..." : "Submit") : "Next"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerificationPage;
